module.exports = __webpack_public_path__ + "static/img/lgy.005fc84.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/lgy.png
// module id = NMYI
// module chunks = 0